import { css } from "@emotion/react";

export const content = css({
  minWidth: 0,
  maxWidth: "100%",
});
